import { useEffect, useState } from 'react'

import { GMT_DISABLED } from '@/constants/config'
import { getMaintenanceStatus } from '@/request/maintenance'
import { logger } from '@/utils/logger'

export const useMaintenanceStatus = (type?: string) => {
  const [isMaintenanceActive, setIsMaintenanceActive] = useState(GMT_DISABLED)

  useEffect(() => {
    if (GMT_DISABLED) return

    const checkMaintenance = async () => {
      try {
        const response = await getMaintenanceStatus(type)
        setIsMaintenanceActive(response.data.isMaintenanceActive)
      } catch (error) {
        // Fail safe: assume no maintenance on error
        logger.error('Error checking maintenance status', error)
        setIsMaintenanceActive(false)
      }
    }

    checkMaintenance()
  }, [type])

  return { isMaintenanceActive }
}
